import { render } from "./create_segment.html?vue&type=template&id=24a20a25&external"
import script from "./create_segment.js?vue&type=script&lang=js&external"
export * from "./create_segment.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__